export const LOYALTY_REDEEM_TEXT_KEY = 'perksReadyToUse';
export const bottomServiceButtonId = 'bottom-service-button';
export const bottomServiceHeadingId = 'bottom-service-heading';
export const bottomServiceDetailsId = 'bottom-service-details';
export const bottomServiceCateringTimeButtonId = 'bottom-service-catering-time-button';
